let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("5zc8S")).then(() => parcelRequire('77xGo'));